import React from "react";
import {IBlock} from "../ListTypeA";
import classes from "./ListTypeABlock.module.scss";

export const ListTypeABlock:React.FC<{block: IBlock}> = ({block})=> {
    return <div className={classes.block}>
        <img src={block.iconSvg} alt={block.iconSvg}/>
        <span className={classes.text}>{block.text}</span>
    </div>
}

